import React from 'react'

function ColumnRowIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polygon points="36.4150391 8.99707031 36.4150391 31.0986328 44.703125 31.0986328 44.703125 0.708984375 14.3134766 0.708984375 14.3134766 8.99707031" opacity="0.6" />
      <rect x="0.5" y="14.5224609" width="30.3896484" height="30.3896484" />
    </svg>
  )
}

export default ColumnRowIcon
